import BubbleChartOutlinedIcon from "@material-ui/icons/BubbleChartOutlined";
import PersonRoleList from "./PersonRoleList";

export default {
  list: PersonRoleList,
  icon: BubbleChartOutlinedIcon,
};
